import CheckHeavyDuty from './features/heavyduty'
import CheckFeature from './checkfeature'
import ClipPlaylist from './features/clipPlaylist'
import StreamAuthentication from './features/streamAuthentication'
import HighQualityCasters from './features/highQualityCasters'
import SelfServe from './features/selfServe'

export enum Feature {
  HEAVY_DUTY_AVAILABLE = 'HeavyDutyMachines',
  HIGH_QUALITY_CASTERS = 'HighQualityCasters',
  CLIP_PLAYLIST = 'ClipPlaylist',
  STREAM_AUTHENTICATION = 'StreamAuthentication',
  SELF_SERVE = 'SelfServe'
}

const features: Record<Feature, CheckFeature> = {
  [Feature.HEAVY_DUTY_AVAILABLE]: new CheckHeavyDuty(),
  [Feature.CLIP_PLAYLIST]: new ClipPlaylist(),
  [Feature.STREAM_AUTHENTICATION]: new StreamAuthentication(),
  [Feature.HIGH_QUALITY_CASTERS]: new HighQualityCasters(),
  [Feature.SELF_SERVE]: new SelfServe()
}

export const hasFeature = (feature: Feature): boolean => {
  const checker = features[feature]
  if (checker === undefined) {
    console.warn(`hasFeature: Trying to check for ${feature} -> does not exist`)
    return false
  }
  return checker.hasFeature()
}

export const teamHasFeature = (teamId: string, feature: Feature): boolean => {
  const checker = features[feature]
  if (checker === undefined) {
    console.warn(`hasFeature: Trying to check for ${feature} -> does not exist`)
    return false
  }
  // this is not a team specific feature
  if (checker.isGlobalFeature()) return false
  return checker.teamHasFeature(teamId)
}

export const updateTeamFeature = (teamId: string, feature: Feature, enabled: boolean): void => {
  const checker = features[feature]
  if (checker === undefined) {
    console.warn(`hasFeature: Trying to update for ${feature} -> does not exist`)
  }
  checker.updateTeamFeature(teamId, enabled)
}

export const isGlobalFeature = (feature: Feature): boolean => {
  const checker = features[feature]
  if (checker === undefined) {
    console.warn(`hasFeature: Trying to access for ${feature} -> does not exists`)
    return false
  }
  return checker.isGlobalFeature()
}
